module.exports = __webpack_public_path__ + "img/cf0b011.png";